const getParamName = (flow) => `is${flow}ModalOpen`;
export const SET_MODAL_STATE = "SET_MODAL_STATE";

export const MODAL_PARAM_HOMEOWNER_LEAD = getParamName("HomeownerLead");

